import "./css/deleteaccount.css"
import { Link, useNavigate } from "react-router-dom";
import { useState, useEffect, useMemo } from "react";

const DeleteAccount = () => {
    const navigate = useNavigate();

    const [passwordBox, setPasswordBox] = useState(false);
    const [page, setPage] = useState(true);
    const [password, setPassword] = useState("");
    const [date, setDate] = useState("");
    const [remaining, setRemaining] = useState(null);

    // हमें अब सिर्फ टोकन और नाम की ज़रूरत है (UI दिखाने के लिए)
    const authData = useMemo(() => {
        return {
            name: localStorage.getItem("name"),
            token: localStorage.getItem("token")
        };
    }, []);

    // 1. Check if account is scheduled for deletion
    useEffect(() => {
        if (!authData.token) {
            navigate("/login");
            return;
        }

        // FIX: हमने query params हटा दिए हैं, क्योंकि बैकएंड अब टोकन से यूज़र को पहचानेगा
        const url = `${process.env.REACT_APP_SERVER_URL}/user/checkaccountdelete`;

        fetch(url, {
            method: "GET",
            headers: {
                "Authorization": `Bearer ${authData.token}`
            }
        })
            .then(res => res.json())
            .then(result => {
                if (result.status === true) {
                    setDate(result.date);
                    setPage(false);
                }
            })
            .catch(err => console.error("Error checking deletion status:", err));
    }, [authData.token, navigate]);

    // 2. Calculate remaining days
    useEffect(() => {
        if (!date) return;
        const requestDate = new Date(date.replaceAll(" ", "-"));
        const today = new Date();
        const diff = today - requestDate;
        const daysPassed = Math.floor(diff / (1000 * 60 * 60 * 24));
        const remainingDays = 30 - daysPassed; // 30 दिन का टाइमर सेट किया है 
        
        setRemaining(remainingDays > 0 ? remainingDays : 0);
    }, [date]);

    const back = () => {
        navigate(-1);
    };

    // 3. Request Account Deletion
    const deleteAccount = async () => {
        if (!password) {
            alert("Please enter your password to confirm.");
            return;
        }

        try {
            const res = await fetch(process.env.REACT_APP_SERVER_URL + "/user/accountdelete", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${authData.token}`
                },
                // FIX: अब हम सिर्फ पासवर्ड भेज रहे हैं, बाकी डिटेल बैकएंड टोकन से निकालेगा
                body: JSON.stringify({ password }) 
            });

            const result = await res.json();
            alert(result.message);

            if (result.status === true) {
                setPasswordBox(false);
                setPassword("");
                window.location.reload(); // पेज रीलोड करके नया स्टेटस दिखाएगा 
            } else if (res.status === 401) {
                // अगर टोकन एक्सपायर हो गया है या पासवर्ड गलत है
                if(result.message.includes("password")){
                    setPassword(""); // पासवर्ड गलत है तो बस फील्ड खाली करो
                } else {
                    navigate("/login"); // ऑथेंटिकेशन फेल हुआ तो लॉगिन पर भेजो
                }
            }
        } catch (error) {
            console.error("Deletion Error:", error);
            alert("Something went wrong. Please try again later.");
        }
    };

    // 4. Cancel Deletion Request
    const cancelRequest = async () => {
        try {
            const res = await fetch(process.env.REACT_APP_SERVER_URL + "/user/cancalrequest", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${authData.token}`
                },
                // FIX: हमें बॉडी में कुछ भेजने की ज़रूरत नहीं है, बैकएंड टोकन का इस्तेमाल करेगा
                body: JSON.stringify({}) 
            });

            const result = await res.json();
            alert(result.message);

            if (result.status === true) {
                window.location.reload(); // पेज रीलोड करके नॉर्मल प्रोफाइल व्यू दिखाएगा
            }
        } catch (error) {
            console.error("Cancel Error:", error);
            alert("Something went wrong. Please try again later.");
        }
    };

    return (
        <div className="deletePageWrapper">
            
            {/* --- DELETE REQUEST ACTIVE --- */}
            {!page &&
                <div className="deleteMainContainer">
                    <div className="deleteContentCard warningCard">
                        <div className="deleteHeader">
                            <i className="fa-solid fa-triangle-exclamation warningIcon"></i>
                            <h2>Account Deletion in Progress</h2>
                        </div>

                        <div className="deleteTextContent">
                            <p>Your account deletion request was accepted on <b>{date.replace(/ /g, "/")}</b>.</p>
                            <p>Your account will be deleted automatically after 30 days.</p>
                            <div className="remainingDaysBox">
                                <span className="daysNumber">{remaining}</span> 
                                <span className="daysText">days remaining before your account is permanently deleted.</span>
                            </div>
                            <p className="cancelNote">If you requested this by mistake, you can withdraw the request by clicking the Cancel button below.</p>
                        </div>

                        <div className="deleteActionButtons rightAlign">
                            <button className="primaryBtn" onClick={cancelRequest}>Cancel Request</button>
                        </div>
                    </div>
                </div>
            }

            {/* --- DELETE PAGE (Initial View) --- */}
            {page &&
                <div className="deleteMainContainer">
                    <div className="deleteContentCard">
                        <div className="deleteHeader">
                            <i className="fa-solid fa-user-xmark dangerIcon"></i>
                            <h2>Delete Account</h2>
                        </div>

                        <div className="deleteTextContent">
                            <p className="greetingText">Hi <b>{authData.name || "User"}</b>,</p>

                            <p>
                                We trust that our services have contributed positively to your learning experience.
                                Our platform is continually enhanced with new features, and our support team is always available to assist you.
                            </p>

                            <p>
                                If you have faced any inconvenience, please let us know — we are ready to help.
                                You can <Link to="/contact" className="textLink">click here</Link> to contact our support team or send us an email at <span className="highlightMail">{process.env.REACT_APP_APP_EMAIL}</span>.
                            </p>

                            <div className="dangerAlertBox">
                                <i className="fa-solid fa-circle-info"></i>
                                <p>
                                    Please note that deleting your account will permanently erase all your data after 30 days,
                                    and any remaining balance is non-refundable.
                                </p>
                            </div>

                            <p className="farewellText">
                                We truly value your presence on {process.env.REACT_APP_APP_NAME}.
                            </p>
                        </div>

                        <div className="deleteActionButtons centerAlign">
                            <button className="secondaryBtn" onClick={back}>Go Back</button>
                            <button className="dangerBtn" onClick={() => setPasswordBox(true)}>Delete My Account</button>
                        </div>
                    </div>

                    {/* --- PASSWORD MODAL --- */}
                    {passwordBox &&
                        <div className="passwordModalOverlay">
                            <div className="passwordModalBox">
                                <h3>Confirm Deletion</h3>
                                <p>Please enter your password to confirm account deletion.</p>
                                
                                <div className="modalInputWrapper">
                                    <i className="fa-solid fa-lock"></i>
                                    <input
                                        type="password"
                                        placeholder="Enter Password"
                                        onChange={(e) => setPassword(e.target.value)}
                                        value={password}
                                    />
                                </div>

                                <div className="modalActionButtons">
                                    <button className="secondaryBtn" onClick={() => {setPasswordBox(false); setPassword("");}}>Cancel</button>
                                    <button className="dangerBtn" onClick={deleteAccount}>Confirm Delete</button>
                                </div>
                            </div>
                        </div>
                    }
                </div>
            }
        </div>
    );
};

export default DeleteAccount;